import mutations from './mutations'

const state = {
  /* Aside menu */
  isAsideVisible: false,
  isAsideWideActive: false,
  secondaryMenu: null,
  primaryMenuIsActiveForcedState: null,

  /* Navbar */
  isNavBarVisible: true,
  isNavBarMenusHoverable: false,
  navBarDropdownsForcedClose: null,
  navBarUpdatesLevel: null,

  /* TitleBar */
  isTitleBarVisible: true,
  titleBarTitleStack: null,

  /* HeroBar */
  isHeroBarVisible: true,
  isHeroBarMainActive: null,
  heroBarHeadline: null,

  /* FooterBar */
  isFooterBarVisible: true
}

export default {
  namespaced: true,
  state,
  mutations
}
